import { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import Avatar from '../../components/Avatar/Avatar';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faUser, faMessage } from "@fortawesome/free-solid-svg-icons";
import './ArtistCard.scss';

export default function ArtistCard({ displayName, afterRender }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!displayName) return;

    const fetchProfile = async () => {
      try {
        const response = await api.get(`/profiles/display_name/${displayName}`);
        setProfile(response.data);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [displayName]);

  useEffect(() => {
    if (!loading && afterRender) {
      afterRender(profile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, profile]);

  if (loading) {
    return (
      <div className="artist-card-content">
        <div className="artist-card glass">
          <div className="artist-card__info">Loading...</div>
        </div>
      </div>
    );
  }

  if (error || !profile) {
    return (
      <div className="artist-card-content">
        <div className="artist-card glass">
          <div className="artist-card__info">Failed to load artist.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="artist-card-content">
      <div className="artist-card glass">
        <a
          href={`/a/${profile.display_name}`}
          target="_blank"
          rel="noopener noreferrer"
          className="artist-card__avatar-link"
        >
          <Avatar profile={profile} className="artist-card__avatar" />
        </a>
        <div className="artist-card__info">
          <a
            href={`/a/${profile.display_name}`}
            target="_blank"
            rel="noopener noreferrer"
            className="artist-card__name"
          >
            {profile.name}
          </a>
          {profile.address && (
            <div className="artist-card__location">
              <FontAwesomeIcon icon={faLocationDot} className="artist-card__location-icon" />{" "}
              {profile.address}
            </div>
          )}
          {profile.bio && (
            <div className="artist-card__bio">{profile.bio}</div>
          )}
          <div className="artist-card__actions">
            <a
              href={`/a/${profile.display_name}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ppy-btn ppy-btn-secondary"
            >
              <FontAwesomeIcon icon={faUser} /> View Profile
            </a>
            <a
              href={`/inbox/${profile.display_name}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ppy-btn ppy-btn-primary"
            >
              <FontAwesomeIcon icon={faMessage} /> Message
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
